import {Component, HostBinding, inject, Input, OnInit} from '@angular/core';
import {BlockElementWorker} from 'app/entities/blockElements/blockElementWorker';
import {UserModelService} from 'app/models/user-model.service';
import {WorkerShort} from 'app/entities/workerShort.entity';
import {User} from 'app/entities/user.entity';
import {BlockElementAbstractComponent} from 'app/components/blocks/components/blockElementCore';

@Component({
  selector: 'app-block-worker-container',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class BlockElementWorkerComponent extends BlockElementAbstractComponent<BlockElementWorker> implements OnInit {
  workerOrUser: WorkerShort | User = null;

  userModelService = inject(UserModelService);

  ngOnInit() {
    this.workerOrUser = this.getWorkerOrUser();
  }

  checkIfYou() {
    if (this.blockElement) {
      if (this.blockElement.worker && this.userModelService.worker) {
        return this.blockElement.worker.id === this.userModelService.worker.id;
      }

      if (this.blockElement.user && this.userModelService.user) {
        return this.blockElement.user.id === this.userModelService.user.id;
      }
    }

    return false;
  }

  getWorkerOrUser(): WorkerShort | User {
    return this.blockElement.worker ? this.blockElement.worker : (this.blockElement.user ? this.blockElement.user : null);
  }
}
